import { NavLink, useLocation } from "react-router-dom";
import { MenuItem, SubMenu } from "react-pro-sidebar";

const GlobalMenuItem = ({
  icon,
  label,
  to,
  userTypeCondition = true,
  subMenuItems = [],
  isSubMenu = false,
  openSubMenu,
  handleSubMenuClick,
  subMenuKey,
  design = {},
  activeUrls = [],
  fun,
}) => {
  const location = useLocation();
  const isActive = activeUrls.includes(location.pathname);

  if (!userTypeCondition) return null;

  // --- SubMenu Rendering ---
  if (isSubMenu) {
    // Check if any child is active
    const isChildActive = subMenuItems.some(
      (item) => item.to === location.pathname
    );

    // Determine if submenu should be open
    // Only use active child detection if submenu hasn't been manually toggled
    const shouldBeOpen = openSubMenu === subMenuKey || (openSubMenu === null && isChildActive);

    return (
      <SubMenu
        title={label}
        label={label}
        className="nothover teenfontsize"
        key={subMenuKey}
        open={shouldBeOpen}
        onClick={() => handleSubMenuClick(subMenuKey)}
        icon={icon}
      >
        {subMenuItems.map((item, index) => (
          <GlobalMenuItem
            key={index}
            {...item}
            activeUrls={activeUrls}
            openSubMenu={openSubMenu}
            handleSubMenuClick={handleSubMenuClick}
          />
        ))}
      </SubMenu>
    );
  }

  // --- Regular MenuItem Rendering ---
  if (to) {
    return (
      <NavLink
        to={to}
        state={{ pageName: label }}
        className={({ isActive: linkActive }) =>
          linkActive || isActive
            ? "nav block text-white font-medium"
            : "nav block text-default font-medium"
        }
        onClick={fun}
      >
        <MenuItem className="nothover teenfontsize" style={design} icon={icon}>
          {label}
        </MenuItem>
      </NavLink>
    );
  }

  // --- Click-only MenuItem (no route) ---
  return (
    <div
      className="nav block text-default font-medium cursor-pointer"
      onClick={fun}
    >
      <MenuItem className="nothover teenfontsize" style={design} icon={icon}>
        {label}
      </MenuItem>
    </div>
  );
};

export default GlobalMenuItem;